export enum Color {
    White = 'white',
    Black = 'black'
}
